export default {
  'categories.activities': 'Activities',
  'categories.animals-nature': 'Animals & Nature',
  'categories.custom': 'Custom',
  'categories.flags': 'Flags',
  'categories.food-drink': 'Food & Drink',
  'categories.objects': 'Objects',
  'categories.people-body': 'People & Body',
  'categories.recents': 'Recently Used',
  'categories.smileys-emotion': 'Smileys & Emotion',
  'categories.symbols': 'Symbols',
  'categories.travel-places': 'Travel & Places',
  'error.load': 'Failed to load emojis',
  'recents.clear': 'Clear recent emojis',
  'recents.none': 'You haven\'t selected any emojis yet.',
  'retry': 'Try again',
  'search.clear': 'Clear search',
  'search.error': 'Failed to search emojis',
  'search.notFound': 'No results found',
  'search': 'Search emojis...'
};
